//BUYERS Listing
export const FETCH_BUYERS_LISTING_FAILURE = 'FETCH_BUYERS_LISTING_FAILURE';
export const FETCH_BUYERS_LISTING_SUCCESS = 'FETCH_BUYERS_LISTING_SUCCESS';

export const RESET = 'RESET';
